import InputGroup2 from '../components/InputGroup2';
import { useIsReadOnly, useMonthlyReportStore } from '../../../store/reportStore';

const AttendanceCount = () => {
  const { reportMxData, setReportMxData } = useMonthlyReportStore();
  const isReadOnly = useIsReadOnly();

  return (
    <div className="row">
      <div className="panel">
        <div className="panel-heading">
          <h3>예배 평균 출석자 수</h3>
        </div>
        <div className="panel-body">
          <div className="col-xs-6 col-sm-4 col-md-4">
            <InputGroup2
              title={'화요일'} //
              value={reportMxData?.attendance_tue}
              setReportMxData={setReportMxData}
              reportColumnName={'attendance_tue'}
              disabled={isReadOnly}
              unit={'명'}
            />
          </div>
          <div className="col-xs-6 col-sm-4 col-md-4">
            <InputGroup2
              title={'금요일'} //
              value={reportMxData?.attendance_fri}
              setReportMxData={setReportMxData}
              reportColumnName={'attendance_fri'}
              disabled={isReadOnly}
              unit={'명'}
            />
          </div>
          <div className="col-xs-6 col-sm-4 col-md-4">
            <InputGroup2
              title={'안식일'} //
              value={reportMxData?.attendance_sat}
              setReportMxData={setReportMxData}
              reportColumnName={'attendance_sat'}
              disabled={isReadOnly}
              unit={'명'}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default AttendanceCount;
